<template lang="pug">
	div(v-if="contrato")
		//- div(style="background-color:#3d4451;color:white;padding: 5px;border-bottom:1px solid #e0e0e0;margin-top: -20px;")
		//- 	nav.nav.nav-pills.nav-justified.m-3
		//- 		a.nav-link(style="cursor:pointer;", :class="(vista === 'detalles') ? 'active' : ''", @click="setVista('detalles')")
		//- 			span.fa.fa-eye.mr-2
		//- 			| Detalles
		//- 		a.nav-link(style="cursor:pointer;", :class="(vista === 'radiacion') ? 'active' : ''", @click="setVista('radiacion')", v-if="mostrarRadiacion")
		//- 			span.fa.fa-list.mr-2
		//- 			| Radiación
		div.container-fluid
			detalles-contrato(v-show="vista === 'detalles'", :contrato.sync="contrato")
			radiacion-contrato(v-if="mostrarRadiacion", v-show="vista === 'radiacion'", :contrato.sync="contrato")
</template>

<script>
import DetallesContrato from './detalles'
import RadiacionContrato from './radiacion'
import API from './../../services/api'
import { mapGetters } from 'vuex'
export default {
	components: {
		'detalles-contrato': DetallesContrato,
		'radiacion-contrato': RadiacionContrato
	},
	data () {
		return {
			vista: 'detalles',
			contrato: null,
			ContratoID: null
		}
	},
	beforeRouteUpdate (to, from, next) {
		if (to.params.vista) {
			this.vista = to.params.vista
		}
		next()
	},
	created () {
		this.ContratoID = this.$route.params.id

		if (this.ContratoID === 'nuevo') {
			this.nuevoContrato()
		} else {
			this.getContrato()
		}
	},

	computed: {
		...mapGetters({
			usuario: 'session/usuario',
			permisos: 'permisos/permisos'
		}),
		mostrarRadiacion () {
			return false
		}
	},

	methods: {
		nuevoContrato () {
			this.contrato = {
				ContratoID: 'nuevo',
				ContratoOriginal: null,
				FormaDePagoID: null,
				IBAN: null,
				EmpresaID: null,
				AgenteID: this.usuario.ID,
				AnuncianteID: null,
				AnuncianteNombre: '',
				AgenteNombre: this.usuario.nombre + ' ' + this.usuario.apellidos,
				ClienteID: null,
				ClienteNombre: null,
				DestinoID: null,
				DestinoNombre: null,
				IntermediarioID: null,
				DescuentoCadenaValor: 0,
				DescuentoComercial: 0,
				IntermediarioNombre: null,
				Titulo: null,
				FechaInicio: null,
				FechaFin: null,
				PartidaID: null,
				EventoID: null,
				Comentarios: null,
				FacturacionEnNeto: false,
				lineas: [],
				facturacion: [],
				recibos: [],
				cliente: {
					ClienteID: null,
					Representante: null,
					CIF: null,
					NombreCliente: null,
					Telefono: null,
					Email: null,
					Direccion: null,
					IBAN: null
				}
			}
		},
		setVista (vista) {
			this.$router.push('/main/contratos/editar/' + this.contrato.ContratoID + '/' + vista)
		},
		getContrato () {
			API.getContrato(this.ContratoID)
				.then(contrato => {
					console.log(contrato)
					this.contrato = contrato
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		}
	}
}
</script>




// WEBPACK FOOTER //
// src/modulos/mis-contratos/vue/components/contrato/index.vue